import _ from "lodash";
import { checkKnownDateOrString } from "../../common";

export function QualityReportGroupDetails({ data }) {
  return Object.keys(data).map((oneKey, i) => {
    return (
      <div className="row" key={i}>
        <div className="column">{_.startCase(Object.keys(data)[i]) + ":"}</div>
        <div className="column">
          {checkKnownDateOrString(oneKey, data[oneKey])}
        </div>
      </div>
    );
  });
}
